import { render, staticRenderFns } from "./FormularioCostos.vue?vue&type=template&id=aff13c1e&"
import script from "./FormularioCostos.vue?vue&type=script&lang=ts&"
export * from "./FormularioCostos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports